@if ({
  stockProtectionDetails: stockProtectionDetails$ | async,
  errorOverview: errorOverview$ | async
  }; as type) {
  @if (stockProtectionDetails || errorOverview) {
    <div class="modal-header">
      <h4 class="modal-title" id="modal-title">
        {{ 'customStockProtection.details.title' | cxTranslate }}
      </h4>
      <button
        type="button"
        class="close"
        aria-describedby="modal-title"
        (click)="modal.dismiss('Cross click')"
        >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container-fluid">
        <div class="stockProtectionDetails">
          <div class="row">
            <div class="col-4 col-sm-4">
              <p> {{ 'customStockProtection.uigProcess' | cxTranslate }}: </p>
            </div>
            <div class="col-4 col-sm-4">
              <p> {{ processNumber }}</p>
            </div>
          </div>
          <div class="row">
            <div class="col-4 col-sm-4">
              <p> {{ 'customStockProtection.articleNumber' | cxTranslate }}: </p>
            </div>
            <div class="col-4 col-sm-4">
              <p> {{ productCode }}</p>
            </div>
          </div>
        </div>
        @if (!inactive) {
          <div class="instructionsParagraph"
            [innerHTML]="'customStockProtection.details.updateParagraph' | cxTranslate">
          </div>
        }
        <form #updateForm="ngForm" autocomplete="off">
          <table class="table stock-protection-details-table">
            <thead class="stock-protection-details-thead-mobile">
              <th scope="col" class="serialNumbers">
                {{ 'customStockProtection.details.serialNumbers' | cxTranslate }}
              </th>
              <th scope="col" class="status">
                {{ 'customStockProtection.status' | cxTranslate }}
              </th>
              <th scope="col" class="deliveryStatus">
                {{ 'customStockProtection.details.deliveryStatus' | cxTranslate }}
              </th>
              @if (!inactive) {
                <th scope="col" class="serialUpdate">
                </th>
              }
            </thead>
            <tbody>
              @if (serialNumbersData.length === 0 && inactive) {
                <tr>
                  <td class="stockProtectionDetailsEmpty" colspan="3">
                    {{  'customStockProtection.emptyTable' | cxTranslate }}
                  </td>
                </tr>
              }
              @for (serialNumberData of serialNumbersData; track serialNumberData; let i = $index) {
                <tr>
                  <!--Serial Number-->
                  @if (inactive) {
                    <td class="serialNumber">
                      <div class="d-md-none stock-protection-details-label">
                        {{ 'customStockProtection.details.serialNumbers' | cxTranslate }}
                      </div>
                      <div class="stock-protection-details-value">
                        {{serialNumberData.serialNumber}}
                      </div>
                    </td>
                  }
                  <!-- Serial Number New-->
                  @if (!inactive) {
                    <td class="updateSerialNumber">
                      <div class="d-md-none stock-protection-details-label">&nbsp;</div>
                      <div class="stock-protection-details-value">
                        <input
                          type="text"
                          class="form-control"
                          name="updateSerialNumber[{{ i }}]"
                          [value]="serialNumberData.serialNumber"
                          [ngModel]="serialNumberData.serialNumber"
                          />
                        </div>
                      </td>
                    }
                    <!--Status-->
                    <td class="serialStatus">
                      <div class="d-md-none stock-protection-details-label">
                        {{ 'customStockProtection.status' | cxTranslate }}
                      </div>
                      <div class="stock-protection-details-value">
                        @switch (serialNumberData.statusCode) {
                          @case ('001') {
                            <img src="assets/images/stockprotection/03.gif"
                              title="{{'customStockProtection.states.valid' | cxTranslate}}"
                              />
                          }
                          @case ('002') {
                            <img src="assets/images/stockprotection/06.gif"
                              title="{{'customStockProtection.states.notfound' | cxTranslate}}"
                              />
                          }
                          @case ('003') {
                            <img src="assets/images/stockprotection/06.gif"
                              title="{{'customStockProtection.states.invalid' | cxTranslate}}"
                              />
                          }
                          @default {
                            {{ serialNumberData.statusCode }}
                          }
                        }
                      </div>
                    </td>
                    <!--Delivery Status-->
                    <td class="deliveryStatus">
                      <div class="d-md-none stock-protection-details-label">
                        {{ 'customStockProtection.details.deliveryStatus' | cxTranslate }}
                      </div>
                      @if (serialNumberData.statusDeliveryCode) {
                        <div class="stock-protection-details-value">
                          {{'customStockProtection.deliveryStatus.' + serialNumberData.statusDeliveryCode | cxTranslate }}
                        </div>
                      }
                    </td>
                    <!--Delete Serial Number-->
                    @if (!inactive) {
                      <td class="deleteSerialNumber">
                        <div class="d-md-none stock-protection-details-label">&nbsp;</div>
                        <div class="stock-protection-details-value">
                          <a
                            class="delete"
                    title="{{
                      'customStockProtection.buttons.delete' | cxTranslate
                    }}"
                    (click)="
                      onDeleteSerialNumber(i)
                    "
                            >
                            <cx-icon type="TRASH"></cx-icon>
                          </a>
                        </div>
                      </td>
                    }
                  </tr>
                }
                @if (!inactive && addRow) {
                  <tr>
                    <td class="newSerialNumber">
                      <div class="d-md-none stock-protection-details-label">&nbsp;</div>
                      <div class="stock-protection-details-value">
                        <input
                          type="text"
                          id="newSerialNumber"
                          class="form-control"
                          [(ngModel)]="newSerialNumber"
                          name="newSerialNumber"
                          [value]="newSerialNumber"
                          />
                        </div>
                      </td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <!--Add Serial Number-->
                      <td class="addSerialNumber">
                        <div class="d-md-none stock-protection-details-label">&nbsp;</div>
                        <div class="stock-protection-details-value">
                          <a
                            class="add"
                  title="{{
                    'customStockProtection.buttons.add' | cxTranslate
                  }}"
                  (click)="
                    onAddSerialNumber()"
                            >
                            <cx-icon type="EXPAND"></cx-icon>
                          </a>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </form>
          </div>
        </div>
        <div class="modal-footer">
          @if (inactive) {
            <button
              type="button"
              class="btn btn-secondary btn-block col-sm-3"
              (click)="modal.dismiss('cancel click')"
              >
              {{ 'customStockProtection.instructions.close' | cxTranslate }}
            </button>
          }
          @if (!inactive) {
            <button
              type="button"
              class="btn btn-secondary col-sm-3"
              type="button"
              (click)="onUpdate()"
              >
              {{ 'customStockProtection.buttons.check' | cxTranslate }}
            </button>
          }
          @if (!inactive) {
            <button
              type="button"
              class="btn btn-secondary col-sm-3"
              type="button"
              (click)="onSave()"
              >
              {{ 'customStockProtection.buttons.save' | cxTranslate }}
            </button>
          }
        </div>
      } @else {
        <cx-spinner></cx-spinner>
      }
    }